import { preInsert, preRemove, preSave } from '@/rxdb/defaultHooks';
import defaultReplication from '@/rxdb/defaultReplication';

export const invoices = {
    schema: {
        title: 'invoice schema',
        version: 5,
        description: 'describes a invoice',
        primaryKey: 'id',
        type: 'object',
        properties: {
            id: { type: 'string', final: true, maxLength: 40 },
            projectId: { type: ['string', 'null'] },
            groupId: { type: ['string', 'null'] },
            emitterId: { type: ['string', 'null'] },

            code: { type: ['string', 'null'] },
            object: { type: ['string', 'null'] },
            amountTTC: { type: ['number', 'string', 'null'] },
            amountHT: { type: ['number', 'string', 'null'] },
            invoiceComment: { type: ['string', 'null'] },

            emissionDate: { type: ['string', 'null'] },
            conclusionDate: { type: ['string', 'null'] },
            conclusion: { type: ['string', 'null'] },
            invoiceDate: { type: ['string', 'null'] },
            distribution: { type: ['array', 'null'] },
            distributionByAmendments: { type: ['array', 'null'] },
            validatedDistributionByAmendments: { type: ['array', 'null'] },
            situationDistribution: { type: ['array', 'null'] },
            chargedDeductions: { type: ['array', 'null'] },
            situationEmissionDate: { type: ['string', 'null'] },
            situationUrl: { type: ['string', 'null'] },
            situationFileName: { type: ['string', 'null'] },

            createdAt: { type: ['string', 'null'] },
            updatedAt: { type: ['string', 'null'] },
            deletedAt: { type: ['string', 'null'] },
            createdBy: { type: ['string', 'null'] },
            updatedBy: { type: ['string', 'null'] },
            deletedBy: { type: ['string', 'null'] },
            rootVersion: { type: 'string' },
        },
    },
    options: {
        onCollectionCreated(projectId, rxCollection) {
            rxCollection.replicationState = defaultReplication(rxCollection, projectId);
            rxCollection.preRemove(preRemove, false);
            rxCollection.preInsert(preInsert, false);
            rxCollection.preSave(preSave, false);
        },
    },
    migrationStrategies: {
        1: (doc) => {
            doc.amountTTC = doc.amountHT;
            delete doc.emissionDueDate;
            return doc;
        },
        2: (doc) => doc,
        3: (doc) => {
            return { ...doc, distributionByAmendments: [] };
        },
        4: (doc) => {
            return { ...doc, chargedDeductions: [], situationDistribution: [] };
        },
        5: (doc) => {
            return { ...doc, validatedDistributionByAmendments: [] };
        },
    },
};
